import { Component } from '@opten/compiler/metadata/component';
import {IFramePlayer} from '@opten/player';

@Component({ className: 'js-player' })
export class IFramePlayerComponent {
	constructor(private element: HTMLElement) {
		new IFramePlayer(element);
	}
}